const PushpinFill = ({ width = 20, height = 20, color = 'currentColor', ...props }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 21 20"
      fill="none"
      {...props}
    >
      <path
        d="M19.0946 8.47596L17.9154 9.6543L17.3262 9.06513L13.7912 12.6001L13.2021 15.5468L12.0229 16.7251L8.4879 13.1893L4.3629 17.3143L3.18457 16.136L7.30957 12.011L3.77374 8.47596L4.95207 7.2968L7.89957 6.70763L11.4346 3.17263L10.8454 2.58346L12.0237 1.4043L19.0946 8.47596Z"
        fill={color}
      />
    </svg>
  )
}

export default PushpinFill
